import * as c from 'common/c'

export type MarkerType = {
  id: string
  name: string
  iconName: string
}

export type Marker = {
  id: string
  tenantId: string
  markerTypeId: string
  geom: { type: string; coordinates: number[] }
  timestamp: string
  note: string | null
  createdByUserId: string | null
  createdByOperatorId: string | null
  createdAt: string
  updatedAt: string
  markerType: MarkerType
  createdByUser?: { id: string; fullName: string }
  createdByOperator?: { id: string; name: string }
}

export type MarkerState = {
  markers: Marker[]
  markerTypes: MarkerType[]
  layerVisible: boolean
  visibleTypeIds: string[] | null
  isCreating: boolean
}

const initialState: MarkerState = {
  markers: [],
  markerTypes: [],
  layerVisible: true,
  visibleTypeIds: null,
  isCreating: false,
}

export default (state = initialState, action): MarkerState => {
  switch (action.type) {
    case c.MARKERS_FETCHED:
      return { ...state, markers: action.payload }

    case c.MARKER_TYPES_FETCHED:
      return { ...state, markerTypes: action.payload }

    case c.MARKER_CREATED:
      return { ...state, markers: [...state.markers, ...action.payload] }

    case c.MARKER_DELETED:
      return {
        ...state,
        markers: state.markers.filter((m) => m.id !== action.payload),
      }

    case c.MARKER_UPDATED:
      return {
        ...state,
        markers: state.markers.map((m) =>
          m.id === action.payload.id ? action.payload : m,
        ),
      }

    case c.MARKER_LAYER_TOGGLE:
      return { ...state, layerVisible: !state.layerVisible }

    case c.MARKER_TYPE_FILTER_TOGGLE: {
      const typeId: string = action.payload
      const current = state.visibleTypeIds ?? state.markerTypes.map((t) => t.id)
      const next = current.includes(typeId)
        ? current.filter((id) => id !== typeId)
        : [...current, typeId]
      const allVisible = next.length === state.markerTypes.length
      return { ...state, visibleTypeIds: allVisible ? null : next }
    }

    case c.MARKER_TYPES_SET_ALL_VISIBLE:
      return { ...state, visibleTypeIds: action.payload ? null : [] }

    case c.MARKER_CREATE_MODE_TOGGLE:
      return { ...state, isCreating: !state.isCreating }

    default:
      return state
  }
}
